import type { ReactNode } from "react";
import { cn } from "../../lib/utils";

export type SectionHeadingDot = "coral" | "lilac" | "aqua" | "sun";

interface SectionHeadingProps {
  id?: string;
  dot: SectionHeadingDot;
  title: string;
  /** Texto/elemento a direita da linha (ex: "8 sem foto"). */
  meta?: ReactNode;
  className?: string;
}

/**
 * "Ponto + titulo + linha [+ meta]" — cabecalho de secao do Painel
 * (handoff: "Cadastros do catalogo", "Para fazer hoje"). Fica FORA do
 * cartao que segue; nunca envolver isto num <Card>.
 */
export function SectionHeading({ id, dot, title, meta, className }: SectionHeadingProps): JSX.Element {
  return (
    <div className={cn("cluster section-heading", className)}>
      <span className={`section-heading__dot section-heading__dot--${dot}`} aria-hidden />
      <h2 id={id} className="section-heading__title">
        {title}
      </h2>
      <span className="section-heading__line" aria-hidden />
      {meta ? <span className="section-heading__meta">{meta}</span> : null}
    </div>
  );
}
